// Service location geographic coordinates (real lat/lng)
export const SERVICE_LOCATIONS = [
  // Americas (orange)
  { name: 'Apex (US HQ)', coords: [-78.85, 35.73], region: 'americas', country: 'USA', hub: true },
  { name: 'New York', coords: [-74.006, 40.7128], region: 'americas', country: 'USA' },
  { name: 'Los Angeles', coords: [-118.2437, 34.0522], region: 'americas', country: 'USA' },
  { name: 'Chicago', coords: [-87.6298, 41.8781], region: 'americas', country: 'USA' },
  { name: 'Houston', coords: [-95.3698, 29.7604], region: 'americas', country: 'USA' },
  { name: 'Miami', coords: [-80.1918, 25.7617], region: 'americas', country: 'USA' },
  { name: 'Toronto', coords: [-79.3832, 43.6532], region: 'americas', country: 'Canada' },
  { name: 'Vancouver', coords: [-123.1207, 49.2827], region: 'americas', country: 'Canada' },
  { name: 'Mexico City', coords: [-99.1332, 19.4326], region: 'americas', country: 'Mexico' },
  { name: 'São Paulo', coords: [-46.6333, -23.5505], region: 'americas', country: 'Brazil' },
  { name: 'Buenos Aires', coords: [-58.3816, -34.6037], region: 'americas', country: 'Argentina' },
  { name: 'Santiago', coords: [-70.6693, -33.4489], region: 'americas', country: 'Chile' },
  { name: 'Bogotá', coords: [-74.0721, 4.7110], region: 'americas', country: 'Colombia' },

  // Europe (green)
  { name: 'London', coords: [-0.1278, 51.5074], region: 'europe', country: 'UK', hub: true },
  { name: 'Dublin', coords: [-6.2603, 53.3498], region: 'europe', country: 'Ireland' },
  { name: 'Stockholm', coords: [18.0686, 59.3293], region: 'europe', country: 'Sweden' },
  { name: 'Oslo', coords: [10.7522, 59.9139], region: 'europe', country: 'Norway' },
  { name: 'Paris', coords: [2.3522, 48.8566], region: 'europe', country: 'France' },
  { name: 'Berlin', coords: [13.4050, 52.5200], region: 'europe', country: 'Germany', hub: true },
  { name: 'Zürich', coords: [8.5417, 47.3769], region: 'europe', country: 'Switzerland' },
  { name: 'Amsterdam', coords: [4.9041, 52.3676], region: 'europe', country: 'Netherlands' },
  { name: 'Vienna', coords: [16.3738, 48.2082], region: 'europe', country: 'Austria' },
  { name: 'Brussels', coords: [4.3517, 50.8503], region: 'europe', country: 'Belgium' },
  { name: 'Warsaw', coords: [21.0122, 52.2297], region: 'europe', country: 'Poland' },
  { name: 'Moscow', coords: [37.6173, 55.7558], region: 'europe', country: 'Russia' },
  { name: 'Athens', coords: [23.7275, 37.9838], region: 'europe', country: 'Greece' },
  { name: 'Rome', coords: [12.4964, 41.9028], region: 'europe', country: 'Italy' },
  { name: 'Madrid', coords: [-3.7038, 40.4168], region: 'europe', country: 'Spain' },

  // Asia (green)
  { name: 'Pune (India HQ)', coords: [73.8567, 18.5204], region: 'asia', country: 'India', hub: true },
  { name: 'Mumbai', coords: [72.8777, 19.0760], region: 'asia', country: 'India' },
  { name: 'Delhi', coords: [77.1025, 28.7041], region: 'asia', country: 'India' },
  { name: 'Bangalore', coords: [77.5946, 12.9716], region: 'asia', country: 'India' },
  { name: 'Chennai', coords: [80.2707, 13.0827], region: 'asia', country: 'India' },
  { name: 'Beijing', coords: [116.4074, 39.9042], region: 'asia', country: 'China', hub: true },
  { name: 'Shanghai', coords: [121.4737, 31.2304], region: 'asia', country: 'China' },
  { name: 'Tokyo', coords: [139.6917, 35.6895], region: 'asia', country: 'Japan' },
  { name: 'Jakarta', coords: [106.8456, -6.2088], region: 'asia', country: 'Indonesia' },
  { name: 'Kuala Lumpur', coords: [101.6869, 3.1390], region: 'asia', country: 'Malaysia' },
  { name: 'Manila', coords: [120.9842, 14.5995], region: 'asia', country: 'Philippines' },
  { name: 'Singapore', coords: [103.8198, 1.3521], region: 'asia', country: 'Singapore' },
  { name: 'Hanoi', coords: [105.8542, 21.0285], region: 'asia', country: 'Vietnam' },
  { name: 'Manama', coords: [50.5860, 26.2235], region: 'asia', country: 'Bahrain' },
  { name: 'Muscat', coords: [58.4059, 23.5880], region: 'asia', country: 'Oman' },
  { name: 'Kuwait City', coords: [47.9774, 29.3759], region: 'asia', country: 'Kuwait' },
  { name: 'Riyadh', coords: [46.6753, 24.7136], region: 'asia', country: 'Saudi Arabia', hub: true },
  { name: 'Dubai', coords: [55.2708, 25.2048], region: 'asia', country: 'UAE', hub: true },
  { name: 'Doha', coords: [51.5310, 25.2854], region: 'asia', country: 'Qatar' },
  { name: 'Amman', coords: [35.9106, 31.9539], region: 'asia', country: 'Jordan' },
  { name: 'Baghdad', coords: [44.3661, 33.3152], region: 'asia', country: 'Iraq' },

  // Oceania (orange)
  { name: 'Sydney', coords: [151.2093, -33.8688], region: 'oceania', country: 'Australia', hub: true },
  { name: 'Melbourne', coords: [144.9631, -37.8136], region: 'oceania', country: 'Australia' },
  { name: 'Perth', coords: [115.8605, -31.9505], region: 'oceania', country: 'Australia' },
  { name: 'Auckland', coords: [174.7633, -36.8485], region: 'oceania', country: 'New Zealand' }
];

// ISO 3166-1 numeric -> region (for highlighting served countries)
// Country names served (matching topojson country.properties.name)
export const SERVED_COUNTRIES = new Set([
  'United States of America', 'Canada', 'Mexico', 'Brazil', 'Argentina', 'Chile', 'Colombia', 'Peru', 'Venezuela',
  'United Kingdom', 'Ireland', 'Sweden', 'Norway', 'France', 'Germany', 'Switzerland', 'Netherlands',
  'Austria', 'Belgium', 'Poland', 'Russia', 'Greece', 'Italy', 'Spain', 'Portugal',
  'India', 'China', 'Japan', 'Indonesia', 'Malaysia', 'Philippines', 'Singapore', 'Vietnam',
  'Bahrain', 'Oman', 'Kuwait', 'Saudi Arabia', 'United Arab Emirates', 'Qatar', 'Jordan', 'Iraq',
  'Australia', 'New Zealand'
]);

// Hub-to-hub flight connections (animated arcs)
export const HUB_CONNECTIONS = [
  { from: [-78.85, 35.73], to: [-0.1278, 51.5074], name: 'US-UK' },
  { from: [-0.1278, 51.5074], to: [13.4050, 52.52], name: 'UK-DE' },
  { from: [13.4050, 52.52], to: [55.2708, 25.2048], name: 'DE-UAE' },
  { from: [55.2708, 25.2048], to: [73.8567, 18.5204], name: 'UAE-IN' },
  { from: [73.8567, 18.5204], to: [116.4074, 39.9042], name: 'IN-CN' },
  { from: [116.4074, 39.9042], to: [151.2093, -33.8688], name: 'CN-AU' },
  { from: [-78.85, 35.73], to: [73.8567, 18.5204], name: 'US-IN' },
  { from: [46.6753, 24.7136], to: [55.2708, 25.2048], name: 'SA-UAE' }
];
